/** Storefront-only payment gateway identifiers (customer-landing / public booking). */
export const STOREFRONT_GATEWAY_IDS = Object.freeze({
  deluxe: 'deluxe',
  authorize: 'authorize',
});
